import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfigBased, WinConfigUtilBased} from "../../../utils/WinConfigUtil";
import {Outsourced} from "../../../Outsourced";
import {OutsourcedSound} from "../../../sound/OutsourcedSound";
import {ArrayUtils} from "../../../utils/ArrayUtils";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OutsourcedSymbol} from "../../../reels/symbols/OutsourcedSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


/**
 * Created by jonas on 2022-01-12.
 */

export class WinCountUp implements SimplePresentation {

    name:string = "WinCountUp";
    private controller:SimplePresentationRunnerController;

    constructor() {
    }

    shouldRun():boolean {
        return Outsourced.model.gameData.totalSpinWinnings > 0 &&
               Outsourced.model.wins.length == 0 &&
               !Outsourced.model.data.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        this.controller = controller;
        const isBigWin = Outsourced.model.winRatio >= (Outsourced.model.specialWinThresholds() ? 1 : 15);
        if (isBigWin)
            this.bigWin();
        else
            this.regularWin();
    }

    private regularWin():void  {
        const tl = gsap.timeline();

        const canDoCountUp = !Outsourced.isWinBelowStake() && !Outsourced.model.data.brokeTheBank;
        if (canDoCountUp) {
            const configs = WinConfigUtilBased.normalLevels;
            const winLevelConfig = configs.filter((config) => config.fromRatio < Outsourced.model.winRatio).pop();
            const duration = winLevelConfig!.duration;
            const sound = winLevelConfig!.sound;

            tl.add(() => {});
            tl.add(Outsourced.winView.countUpWin(Outsourced.model.gameData.totalSpinWinnings, 0, duration), '>0.25');
            tl.add(() => Outsourced.soundPlayer.playSound(sound.sound), '<');
            tl.add(() => Outsourced.soundPlayer.playSound(sound.end), `>${duration}`);
            // for skip
            tl.add(() => {
                Outsourced.soundPlayer.stopSound(sound.start);
                Outsourced.soundPlayer.stopSound(sound.sound);
            })
        }

        tl.add(() => {
            this.controller.setSkipCallback();
            this.controller.finish()
        });
    }

    private bigWin():void {
        const tl = gsap.timeline({onComplete:() => {
                this.controller.finish()
            }
        });

        tl.add(() => {});
        tl.add(() => Outsourced.soundPlayer.fadeOutMusic(), '>0.5');
        tl.add(() => {}, '>1');
        if (!Outsourced.model.data.brokeTheBank) {
            const bigLevels = Outsourced.model.specialWinThresholds()
                ? WinConfigUtilBased.bigLevelsFeatureBuy
                : WinConfigUtilBased.bigLevels;
            const winRatio = Outsourced.model.winRatio;
            const configs = bigLevels.filter((winLevel) => winLevel.fromRatio < winRatio);

            configs.forEach((config, index) => {
                tl.add(() => {
                    this.controller.setSkipCallback(() => {
                        tl.seek(`bigWinLevel${index}`, false);
                        Outsourced.soundPlayer.stopSound(`bigWinLevel${index + 1}`);
                    });
                });

                const isFirst = index == 0;
                const isLast  = index == (configs.length - 1);
                const to      = Outsourced.getBetPrice() * Math.min(config.toRatio, Outsourced.model.winRatio);
                const from    = Outsourced.getBetPrice() * config.fromRatio;

                tl.add(() => Outsourced.soundPlayer.playSound(`bigWinLevel${index + 1}`));
                tl.add(() => Outsourced.soundPlayer.playSound(OutsourcedSound.BIG_WIN_CHANGE));
                if (isFirst) {
                    tl.add(Outsourced.soundPlayer.playSoundBased("bigWinBoxStart"), '<-1')
                    tl.add(Outsourced.winView.bigWinStart(to, from, index + 1), '<');
                } else {
                    tl.add(Outsourced.winView.bigWinMiddle(to, from, index + 1));
                }
                if (isLast) {
                    tl.add(Outsourced.winView.bigWinEnd(index + 1));
                    tl.add(() => Outsourced.soundPlayer.playSound(OutsourcedSound.BIG_WIN_END), '<');
                    tl.add(() => { this.controller.setSkipCallback(); }, '<')
                }

                tl.addLabel(`bigWinLevel${index}`, isLast ? '<' : '>');
            });

            tl.add(() => Outsourced.soundPlayer.fadeInMusic());
        }

        tl.add(() => {}, '>0.2');
    }
}
